import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useBranding } from '../branding/BrandProvider';

interface HeaderMinimalProps {
  className?: string;
}

export function HeaderMinimal({ className = '' }: HeaderMinimalProps) {
  const { branding, orgName } = useBranding();

  // Ensure consistent rendering by providing fallbacks
  const displayName = orgName || 'Organization';
  const logoUrl = branding?.logoUrl;

  return (
    <header className={`bg-white shadow-sm ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link href="/" className="flex items-center space-x-3 hover:opacity-80 transition-opacity">
            <div className="flex items-center space-x-3">
              {logoUrl ? (
                <div className="relative h-8 w-auto">
                  <Image
                    src={logoUrl}
                    alt={`${displayName} logo`}
                    height={32}
                    width={120}
                    className="h-8 w-auto object-contain"
                    priority
                  />
                </div>
              ) : (
                <div
                  className="h-8 w-8 rounded-md flex items-center justify-center text-white font-bold text-sm"
                  style={{ backgroundColor: 'var(--color-primary)' }}
                >
                  {displayName.substring(0, 2).toUpperCase()}
                </div>
              )}
              <span className="text-xl font-semibold text-gray-900">
                {displayName}
              </span>
            </div>
          </Link>
        </div>
      </div>
    </header>
  );
}
